<template>
  <b-modal :id="modalId" title="Edit Organization" hide-footer size="lg" no-close-on-backdrop>
    <organization-form :organization="organization"
      :isSaving="isSaving"
      @saveOrganization="saveOrganization" />
  </b-modal>
</template>

<script>
import OrganizationForm from '../Forms/OrganizationForm.vue';
import config from '../../constants/config';

export default {
  name: 'EditOrganizationModal',
  components: {
    OrganizationForm
  },
  props: {
    organization: Object
  },
  data() {
    return {
      isSaving: false,
    };
  },
  methods: {
    async saveOrganization(organization) {
      this.isSaving = true;
      const success = await this.$store.dispatch('organization/updateOrganization', organization);

      if (success) {
        this.$store.dispatch('organization/refetchOrganizations');
        this.$bvModal.hide(this.modalId);
      }
      this.isSaving = false;
    }
  },
  computed: {
    modalId() {
      return config.EDIT_ORG_MODAL_ID;
    }
  }
};
</script>
